import { Rule, RuleObject } from 'antd/lib/form';
import TranslateText from 'components/hoc/TranslateText';
import { emailRegExp } from 'enums/regExp';
import React from 'react';

export const emailCheckValidation = (rulesMessage: string, getValueFrom: string): Rule[] => [
    {
        required: true,
        message: <TranslateText>{rulesMessage}</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || emailRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL</TranslateText>);
        }
    }),
    ({ getFieldValue }) => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || getFieldValue(getValueFrom) === value) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL_SHODA</TranslateText>);
        }
    })
];

export default emailCheckValidation;
